export { default } from '../middleware/basic-auth'
